import { portalAction, portalScreenContext } from '../../../../app/telemetry/portalTelemetry';
import { Box, Button, Grid, Tooltip, Typography } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { PcsPlanStatuses } from "../../common/PcsPlanStatuses";
import pcsPlanFormModel from "../../common/pcsPlanFormModel";
import { AppPathEnum } from "../../../../app/enums/appPathEnum";
import { useAppSelector } from "../../../../app/store/configureStore";
import { useState, useEffect } from "react";
import { PcsPdpStatus } from "../../../../app/models/staticData/pcsPdpStatus";
import InfoIcon from '@mui/icons-material/Info';

export function PcsPlanStatus() {
    const { AnnualPlanStatus } = pcsPlanFormModel.formField;

    const { enrolmentYearId } = useParams<{ enrolmentYearId: string }>();

    const { pcsPdpStatuses } = useAppSelector(state => state.ReferenceData);
    const { enrolmentYears } = useAppSelector(state => state.pcsEnrolment);

    const [pcsPdpStatus, setPcsPdpStatus] = useState<PcsPdpStatus>();

    useEffect(() => {
        if (enrolmentYears && enrolmentYears?.length > 0 && pcsPdpStatuses) {
            const enrolmentYear = enrolmentYears?.find(x => x.enrolmentYearId === enrolmentYearId);
            setPcsPdpStatus(pcsPdpStatuses.find(x => x.id === enrolmentYear?.pcsPdpReviewStatusId));
        }
    }, [enrolmentYears, pcsPdpStatuses, enrolmentYearId]);

    return <Box sx={{ minWidth: "100%" }}>
        <Grid container rowSpacing={4}>

            <Grid size={{ xs: 11.5, sm: 11.5 }}>
                <Button component={Link} to={`${AppPathEnum.PCS_PLAN}${window.location.search}`} variant="contained" onClick={portalAction(portalScreenContext('PcsPlanStatus'), 'PcsPlanStatus.navigate', () => {})}>
                    Back to Professional development plans
                </Button>
            </Grid>

            <Grid size={{ xs: 0.5, sm: 0.5 }}></Grid>

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12 }}>
                <Typography variant='h4'>Professional development plan</Typography>
            </Grid>

            <Grid size={{ xs: 4, sm: 3, lg: 2 }}>
                <b>{AnnualPlanStatus.label.trim().endsWith("*") ?
                    AnnualPlanStatus.label.trim().substring(0, (AnnualPlanStatus.label.trim().length - 1)) :
                    AnnualPlanStatus.label}</b>
            </Grid>


            <Grid size={{ xs: 2, sm: 1 }}>
                {pcsPdpStatus?.code && PcsPlanStatuses(pcsPdpStatus?.code) &&
                    <Tooltip title={PcsPlanStatuses(pcsPdpStatus?.code)} placement={'bottom'} arrow enterTouchDelay={0}>
                        <InfoIcon style={{ fontSize: '25px', alignSelf: 'end' }} />
                    </Tooltip>}
            </Grid>

            <Grid size={{ xs: 6, sm: 8 }}>
                {pcsPdpStatus?.value}
            </Grid>

            <Grid size={{ lg: 1 }}></Grid>

            <Grid size={{ xs: 12 }}>
                <Typography variant='subtitle1'>
                    The aim of the professional development plan is to enable you to:
                </Typography>

                <ol type="i">
                    <li>
                        <Typography variant='subtitle1'>
                            Plan your activities that will assist you in meeting your annual PCS requirements.
                        </Typography></li>
                    <li>
                        <Typography variant='subtitle1'>
                            Identify events, meetings, learning materials or discussion topics that will assist you.
                        </Typography>
                    </li>
                    <li>
                        <Typography variant='subtitle1'>
                            Review your completed PDP with practice colleagues.
                        </Typography>
                    </li>
                    <li>
                        <Typography variant='subtitle1'>
                            Reflect on your learning to-date and identify any areas of educational need for the following year?
                        </Typography>
                    </li>
                </ol>
            </Grid>
        </Grid>
    </Box>
}
